import { Component, EventEmitter, Input, OnInit, Output, Pipe } from '@angular/core';
import { CardLinkOfferCategoriesQuery, CardLinkOfferCategory } from '@fgb/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Observable } from 'rxjs';

@Pipe({
  name: 'categoryWidth'
})
export class CategoryWidthPipe {
  transform(value: string): number {
    let categoryLength = value.length;
    if (categoryLength <= 5) {
      return 60;
    } else {
      return categoryLength * 10;
    }
  }
}

@Component({
  selector: 'fgbcl-affiliates-offers-category-filter',
  templateUrl: './affiliates-offers-category-filter.component.html',
  styleUrls: ['./affiliates-offers-category-filter.component.scss'],
})
export class AffiliatesOffersCategoryFilterComponent implements OnInit {
  offersCategories$: Observable<CardLinkOfferCategory[]>;
  offersCategoriesCount$: Observable<number>;

  constructor(private cardLinkOfferCategoriesQuery: CardLinkOfferCategoriesQuery) {}
  @Output() categoryTagIdEmitter = new EventEmitter<number>();
  @Input() navButtons: boolean = false;
  categoryTagId: number = 0;
  customOptions: OwlOptions;

  ngOnInit(): void {
    this.getCategories();
    this.customOptions = {
      autoWidth: true,
      margin: 1,
      pullDrag: true,
      dots: false,
      navSpeed: 700,
      nav: this.navButtons,
      navText: [
        '<span class="d-none d-lg-block icon material-icons">chevron_left</span>',
        '<span class="d-none d-lg-block icon material-icons">chevron_right</span>',
      ],
    };
  }

  /**
   * @fatch categories fom store
   */
  getCategories() {
    this.offersCategories$ = this.cardLinkOfferCategoriesQuery.selectAll();
  }

  /**
   * @emit the category ID
   */
  categoryEmitter(category: any) {
    if (this.categoryTagId != category.TagId) {
      this.categoryTagId = category.TagId;
    } else {
      this.categoryTagId = 0;
    }
    this.categoryTagIdEmitter.emit(this.categoryTagId);
  }
}
